import { SingleSelection } from '../../../../components';
import { useTranslation } from '../../../../hooks';
import useKycLevels from 'src/hooks/useKycLevels';

interface IProps {
  label?: string;
  value: any;
  onChange: (e: any) => void;
  onClear: () => void;
}

const ENUM_KYC_LEVEL = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
};

const KycLevelSingleSelection = (props: IProps) => {
  const { label, value, onChange, onClear } = props;

  const { EnumKycLevels } = useKycLevels();

  const { tc } = useTranslation();

  return (
    <SingleSelection
      label={label || tc('phSelection', { fieldName: tc('kycLevel') })}
      value={value || ''}
      onChange={onChange}
      clearSelect={onClear}
      enumData={ENUM_KYC_LEVEL}
      nameFn={(item) => item}
    />
  );
};

export default KycLevelSingleSelection;
